import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ChevronRightSmall = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-test="chevron-right-small"
    height={height}
    width={width}
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M6.17688 4.51013L9.74988 8.08346C9.7731 8.10665 9.79152 8.13419 9.80409 8.16451C9.81666 8.19482 9.82313 8.22731 9.82313 8.26013C9.82313 8.29295 9.81666 8.32544 9.80409 8.35576C9.79152 8.38607 9.7731 8.41361 9.74988 8.4368L6.17688 12.0101"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
